import { cssRule } from 'typestyle';

cssRule('.tb-popup', {
    position: 'absolute',
    top: '1px',
    right: 0,
    bottom: '1px',
    left: 0,
    visibility: 'hidden',
});

